import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { IntegrationCategory, IntegrationCategoryType } from "@phoenix/common";
import { PhxSelect } from "../../../shared/components/phx-select/phx-select.component";

@Component({
    selector: "app-formly-field-integration-category",
    templateUrl: "./formly-field-integration-category.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        FormsModule,
        FormlyModule,
        ReactiveFormsModule,
        PhxSelect
    ]
})
export class FormlyFieldIntegrationCategoryComponent extends FieldType {
    shopListArray = signal<{ label: string; value: IntegrationCategoryType }[]>([]);

    constructor() {
        super();
        // Map ShopList values to label and key pairs
        const shopListMapped = Object.entries(IntegrationCategory).map(([key, value]) => ({
            label: value as string, // Use the value of the enum/object as the label
            value: key as IntegrationCategoryType // Use the key as the value of type ShopListType
        }));
        this.shopListArray.set(shopListMapped);
    }
}
